import { useCallback, useEffect, useState } from 'react';
import { SubmissionError } from 'redux-form';
import { GET, PATCH, POST } from 'utils/httpMethods';

const toFormValues = ({ name, grantType, clientId, urlSouscription, clientSecret, urlToken, hasManagementAct, isActive }) => ({
    name,
    grantType,
    clientId,
    urlSouscription,
    clientSecret,
    urlToken,
    hasManagementAct,
    isActive,
});

// trie par nom, puis place les partenaires désactivés en fin de liste
export const sortBusinessPartners = (businessPartners) => Object.entries(businessPartners)
    .sort(([, a], [, b]) => (a.isActive === b.isActive ? a.name.localeCompare(b.name) : Number(b.isActive) - Number(a.isActive)));

const useBusinessPartners = () => {
    const [businessPartners, setBusinessPartners] = useState({});

    useEffect(() => {
        (async () => {
            const response = await GET('/api/businessPartners');
            const partners = await response.json();

            setBusinessPartners(partners.reduce((acc, partner) => ({
                ...acc,
                [partner.id]: toFormValues(partner),
            }), {}));
        })();
    }, []);

    const createBusinessPartner = useCallback(async (values) => {
        const alreadyExists = Object.values(businessPartners)
            .some(({ name }) => name.toLowerCase() === values.name.toLowerCase());

        if (alreadyExists) {
            throw new SubmissionError({ name: 'Ce partenaire existe déjà' });
        }

        let created;

        try {
            const response = await POST('/api/businessPartners', { body: values });
            created = await response.json();
        } catch (error) {
            const data = await error.response.json();

            throw new SubmissionError({ _error: 'La création a échoué !', ...data });
        }

        setBusinessPartners({ ...businessPartners, [created.id]: values });
    }, [businessPartners]);

    // la page est rechargée juste après (cf. onSubmitSuccess de BusinessPartnerForm) :
    // pas besoin de remettre à jour l'état local ici
    const saveBusinessPartners = useCallback(async (values) => {
        try {
            await PATCH('/api/businessPartners', { body: values });
        } catch (error) {
            const data = await error.response.json();

            throw new SubmissionError({ _error: 'La modification a échoué !', ...data });
        }
    }, []);

    const toggleBusinessPartnerActive = useCallback(async (id, isActive) => {
        await PATCH(`/api/businessPartners/${id}`, { body: { isActive } });
        document.location.reload();
    }, []);

    return { businessPartners, createBusinessPartner, saveBusinessPartners, toggleBusinessPartnerActive };
};

export default useBusinessPartners;
